import React from 'react';
import t from 'format-message';
import { Checkbox, CheckboxGroup } from '@instructure/ui-checkbox';
import { DisplayFilter } from "../../../../util/gradebook/constants.js";
export var DisplayFilterSelector = function DisplayFilterSelector(_ref) {
  var values = _ref.values,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(CheckboxGroup, {
    name: "display-filter",
    description: t('Display'),
    defaultValue: values,
    onChange: function onChange(values) {
      return _onChange(values);
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    label: t('Unpublished Assignments'),
    value: DisplayFilter.SHOW_UNPUBLISHED_ASSIGNMENTS
  }), /*#__PURE__*/React.createElement(Checkbox, {
    label: t('Outcomes with no results'),
    value: DisplayFilter.SHOW_OUTCOMES_WITH_NO_RESULTS
  }), /*#__PURE__*/React.createElement(Checkbox, {
    label: t('Students with no results'),
    value: DisplayFilter.SHOW_STUDENTS_WITH_NO_RESULTS
  }), /*#__PURE__*/React.createElement(Checkbox, {
    label: t('Avatars in student list'),
    value: DisplayFilter.SHOW_STUDENT_AVATARS
  }));
};